<template>
  <div id="edit-profile-modal">
    <div
      class="modal"
      :class="modalIsActive ? 'is-active' : ''"
    >
      <div
        class="modal-background"
        @click="toggleModal"
      />
      <div class="modal-card card">
        <header class="card-header">
          <section
            id="step-navigation"
            class="section no-pad-top"
          >
            <div class="step-nav-inner">
              <div class="columns is-mobile is-marginless">
                <div class="column has-text-left">
                  <button
                    class="button is-rounded is-success has-text-weight-bold is-outlined"
                    @click="toggleModal"
                  >
                    Discard
                  </button>
                </div>
                <div class="column has-text-right">
                  <button
                    class="button is-rounded is-success has-text-weight-bold"
                    :disabled="!isFormValid"
                    @click="saveProfile"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </section>
        </header>
        <section
          v-if="isLoading"
          class="modal-card-body"
        >
          <loading-spinner />
        </section>
        <section
          v-else-if="!isLoading"
          class="modal-card-body"
        >
          <div v-if="mainDetails">
            <profession-candidate />
            <locations-candidate id="locations" />
          </div>
          <about-candidate
            v-if="bio"
            @checkForm="validate"
          />
          <accomplishments-candidate
            v-if="accomplishments"
            @checkForm="validate"
          />
          <industries-candidate
            v-if="industries"
            @checkForm="validate"
          />
          <skills-candidate
            v-if="skills"
            @checkForm="validate"
          />
          <companies-candidate
            v-if="companies"
            @checkForm="validate"
          />
          <education-candidate
            v-if="education"
            @checkForm="validate"
          />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import AboutCandidate from '@/components/CandidateProfile/AboutCandidate';
import AccomplishmentsCandidate from '@/components/CandidateProfile/AccomplishmentsCandidate';
import CompaniesCandidate from '@/components/CandidateProfile/CompaniesCandidate';
import EducationCandidate from '@/components/CandidateProfile/EducationCandidate';
import IndustriesCandidate from '@/components/CandidateProfile/IndustriesCandidate';
import LocationsCandidate from '@/components/CandidateProfile/LocationsCandidate';
import ProfessionCandidate from '@/components/CandidateProfile/ProfessionCandidate';
import SkillsCandidate from '@/components/CandidateProfile/SkillsCandidate';
import LoadingSpinner from '@/components/Utilities/LoadingSpinner';

export default {
  name: 'EditProfileModal',
  components: {
    AboutCandidate,
    AccomplishmentsCandidate,
    CompaniesCandidate,
    EducationCandidate,
    IndustriesCandidate,
    LocationsCandidate,
    ProfessionCandidate,
    SkillsCandidate,
    LoadingSpinner
  },
  props: {
    mainDetails: {
      type: Boolean,
      required: false,
      default: false
    },
    bio: {
      type: Boolean,
      required: false,
      default: false
    },
    accomplishments: {
      type: Boolean,
      required: false,
      default: false
    },
    industries: {
      type: Boolean,
      required: false,
      default: false
    },
    skills: {
      type: Boolean,
      required: false,
      default: false
    },
    companies: {
      type: Boolean,
      required: false,
      default: false
    },
    education: {
      type: Boolean,
      required: false,
      default: false
    },
    modalIsActive: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      isFormValid: true,
      confirmDiscardChanges: false
    };
  },
  methods: {
    toggleModal () {
      this.$emit('toggleModal', false);
    },
    showConfirmation () {
      this.confirmDiscardChanges = true;
    },
    saveProfile () {
      this.isLoading = true;
      this.$store
        .dispatch('editCandidateProfile', this.$store.getters.getUserProfile)
        .then(response => {
          if (response.data.status !== 'saved') {
            this.isLoading = false;
            this.$toasted.show('Oops, something went wrong!');
          } else {
            this.$store.commit(
              'UPDATE_CANDIDATE_PROFILE',
              response.data.data.profile
            );
            this.$emit('toggleModal', 'saved');
            this.isLoading = false;
            this.$toasted.show('Profile Saved!');
          }
        })
        .catch(error => {
          console.log(error);
          this.isLoading = false;
          this.$toasted.show('Oops, something went wrong!');
        });
    },
    validate ($event) {
      this.isFormValid = $event;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-card {
  padding: 1rem;
  max-height: 80vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  margin: 0 0.5rem;
}

.modal-card-body {
  height: 100%;
  overflow: visible;
}

#locations {
  margin-top: 2rem;
}

#step-navigation {
  background-color: white;
  left: 0;
  top: 0;
  width: 100%;
  padding-top: 0;
  margin-top: 0;
}

.step-nav-inner {
  max-width: 600px;
  margin: 0 auto;
}
</style>
